import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class InvoiceInformationService {
  constructor(private http: HttpClientService) {}

  public create(
    rfc,
    application_id,
    invoice,
    address,
    emails,
    tax_regime,
    use_person_information = true,
    first_name = "",
    middle_name = "",
    first_last_name = "",
    second_last_name = "",
    fiscal_name = ""
  ): Observable<any> {
    const options = {
      rfc,
      application_id,
      invoice,
      address,
      emails,
      tax_regime,
      use_person_information,
      first_name,
      middle_name,
      first_last_name,
      second_last_name,
      fiscal_name,
    };

    return this.http
      .post("/api/invoice_information", options)
      .pipe(tap((_) => console.log("InvoiceInformationService.create: Ok.")));
  }

  public index(application_id): Observable<any> {
    const options = {
      params: {
        application_id,
      },
    };
    return this.http
      .get("/api/invoice_information", options)
      .pipe(tap((_) => console.log("InvoiceInformationService.index: Ok.")));
  }

  public updateInformationFromSat(application_id): Observable<any> {
    const options = {
      application_id,
    };
    return this.http
      .post("/api/invoice_information/update_from_sat", options)
      .pipe(tap((_) => console.log("InvoiceInformationService.updateInformationFromSat: Ok.")));
  }
}
